import { Component, Input } from '@angular/core';

@Component({
  selector: 'inner-orbiting-dot',
  templateUrl: './inner-orbiting-dot.component.html',
  styleUrls: ['./inner-orbiting-dot.component.css']
})
export class InnerOrbitingDotComponent {

  @Input() primaryColor!: string; // Default primary color
  @Input() secondaryColor!: string;
  @Input() thickness!: any;
  @Input() width!: any;

  ngOnInit() {
    this.width = Number(this.width) || 48;   // default to 90 if invalid
    this.thickness = Number(this.thickness) || 3; // default to 4 if invalid
  }
}
